import React from 'react';

import { PageContainerProps } from './PageContainer.props';
import { Root, Children } from './PageContainer.styles';

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  align,
  className
}) => {
  return (
    <Root className={className} align={align}>
      <Children className={className} align={align}>
        {children}
      </Children>
    </Root>
  );
};
